import { ExecutionStatus } from './ExecutionStatus';
import TestExecutionStep from './TestExecutionStep';
import TestStep from './TestStep';
import { TestType } from './TestType';

export type AdjoiningTestCaseInCycle = {
  testCaseId: number;
  testExecutionId: number;
  status: ExecutionStatus;
  testCaseInCycleId: number;
  testType: TestType;
};

export type AdjoiningTestCasesInCycle = {
  prev: AdjoiningTestCaseInCycle;
  next: AdjoiningTestCaseInCycle;
};

export default class TestExecution {
  id: number;
  name: string;
  testCaseIssue: any;
  comment: string;
  testCaseId: string | number;
  testSteps: Array<TestExecutionStep>;
  status: ExecutionStatus;
  createdDate: string;
  testCaseInCycleId: number;
  testCycle: any;
  executionAssignee?: any;
  adjoiningTestCasesInCycle: AdjoiningTestCasesInCycle;
  testType: TestType;

  constructor(
    name: string,
    testCaseId: string | number,
    testSteps: Array<TestStep>,
    status: ExecutionStatus,
    createdDate: number,
    testCaseInCycleId?: number,
    executionAssignee?: any,
    adjoiningTestCasesInCycle?: AdjoiningTestCasesInCycle,
    testType?: TestType
  ) {
    this.name = name;
    this.comment = '';
    this.testCaseId = testCaseId;
    this.testSteps = testSteps.map((ts) => new TestExecutionStep(ts));
    this.status = status;
    this.createdDate = createdDate;
    this.testType = testType;
    this.executionAssignee = executionAssignee;
    if (testCaseInCycleId) {
      this.testCaseInCycleId = testCaseInCycleId;
    }
    this.adjoiningTestCasesInCycle = adjoiningTestCasesInCycle;
  }

  getRequestData() {
    const { testCaseIssue: _testCaseIssue, ...data } = this;
    data.testSteps = data.testSteps.map<any>((ts) => {
      const entityTestStep = ts.toRestEntity();
      return entityTestStep;
    });

    // TODO replace statusObject with status after cleanup
    data.statusObject = data.status;
    if (data.executionAssignee) {
      data.executionAssignee = data.executionAssignee.getIdentifier();
    }

    return data;
  }

  getCreateRequestData() {
    return {
      name: this.name,
      testCaseId: this.testCaseId,
      comment: this.comment,
      ...(this.status ? { statusId: this.status.id } : {}),
      ...(this.executionAssignee
        ? { executionAssignee: this.executionAssignee.getIdentifier() }
        : {}),
      ...(this.testCaseInCycleId
        ? { testCaseInCycleId: this.testCaseInCycleId }
        : {}),
    };
  }

  getUpdateRequestData() {
    return {
      id: this.id,
      fields: {
        comment: this.comment,
        ...(this.status ? { statusId: this.status.id } : {}),
        ...(this.executionAssignee
          ? { executionAssignee: this.executionAssignee.getIdentifier() }
          : {}),
      },
    };
  }
}
